// @ts-nocheck
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import home from "../../assets/images/home-02.svg?url";
import globe from "./../../assets/images/globe-06.svg?url";
import beaker from "./../../assets/images/beaker-02.svg?url";
import shield from "./../../assets/images/shield-tick.svg?url";
import help from "./../../assets/images/help-circle-light.svg?url";
import file from "./../../assets/images/file-heart-02.svg?url";
import flag from "./../../assets/images/Flag-02.svg?url";
import user from "./../../assets/images/user-02.svg?url";
import lineChart from "./../../assets/images/line-chart-up-02.svg?url";
import kanban from "./../../assets/images/kanban-logo.svg?url";
import traceability from "./../../assets/images/traceability.svg?url";

export class CommonNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: null // to track which parent item is expanded
    };
  }

  onSRC = title => {
    if (title === "Home") {
      return home;
    } else if (title === "Web Test Lab") {
      return beaker;
    } else if (title === "Metrics" || title === "Automation Metrics" || title === "Execution Reports") {
      return lineChart;
    } else if (title === "Test Case Management") {
      return traceability;
    } else if (title === "Software Management") {
      return globe;
    } else if (title === "Project") {
      return kanban;
    } else if (title === "License") {
      return shield;
    } else if (title === "Help") {
      return help;
    } else if (title === "Privacy Policy") {
      return file;
    } else if (title === "User") {
      return user;
    } else if (title === "Audit") {
      return flag;
    }
  };

  toggleSubMenu = title => {
    this.setState(prev => ({
      expanded: prev.expanded === title ? null : title
    }));
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ expanded: null });
    }
  };

  render() {
    const navItems = this.props.navItems || [];
    const { expanded } = this.state;

    return (
      <ul className="navigation" ref={node => (this.wrapperRef = node)}>
        {navItems.map(item => {
          /*const hasChildren = item.children?.length;*/
          const hasChildren = item.children && item.children.length;

          const isExpanded = expanded === item.title;

          return (
            <li className="nav-item" key={item.path || item.title}>
              {hasChildren ? (
                <div
                  className="nav-link-parent text-white"
                  onClick={e => {
                    e.stopPropagation();
                    this.toggleSubMenu(item.title);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img src={this.onSRC(item.title)} alt={item.title} />
                  {item.title}
                </div>
              ) : (
                <NavLink className="" to={item.path} onClick={() => this.setState({ expanded: false })}>
                  <img src={this.onSRC(item.title)} alt={item.title} />
                  {item.title}
                  {/* Small "PRO" chip signals paid-feature scope. When
                      license gating lands, MainNav can drop the badge and
                      hide the item outright based on hasFeature(). */}
                  {item.badge && (
                    <span
                      style={{
                        marginLeft: 6,
                        padding: "1px 6px",
                        borderRadius: 4,
                        background: "linear-gradient(135deg,#f59e0b,#f43f5e)",
                        color: "#fff",
                        fontSize: 9,
                        fontWeight: 700,
                        letterSpacing: 0.4,
                        textTransform: "uppercase",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.badge}
                    </span>
                  )}
                </NavLink>
              )}

              {hasChildren && isExpanded && (
                <ul className="submenu">
                  {item.children.map(child => (
                    <li className="nav-subitem" key={child.path}>
                      <NavLink
                        className="text-white"
                        to={child.path}
                        onClick={() => this.setState({ expanded: false })}
                      >
                        {child.title}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    );
  }
}
